import { FC } from 'react';
import ScanPage from './scanPage';
import Header, { IScanPageHeaderComponent } from './header';
import Body, { IScanPageBodyComponent } from './body';
import { ScanPageProps } from './interface';

export type IScanPageComponent = FC<ScanPageProps> & {
  Header: IScanPageHeaderComponent;
  Body: IScanPageBodyComponent;
};
/** 扫码作业页面 */
const TransScanPage = ScanPage as IScanPageComponent;
TransScanPage.Header = Header;
TransScanPage.Body = Body;

export default TransScanPage;
